import { Injectable } from '@angular/core';
import { ILicenseProviderService } from '@nimbus-library/features/feature-permission/services/contracts/i-license-provider.service';
import { ILicenseCollection } from '@nimbus-library/features/feature-permission/models/i-license-collection.model';
@Injectable()
export class LicenseProviderService extends ILicenseProviderService {
  protected licenseCollectionDefinition: ILicenseCollection<string>[] = [];
}
